import React, { Suspense } from 'react';
import { isBrowser } from './Browser';
import { LogRocketWrapper } from './LogRocketWrapper';
import log from 'loglevel';


const shouldCreateLogRocket = () => {
  if (!isBrowser()) {
    return true;  // Do this to ensure the component gets bundled at build time
  }
  const { userAgent } = navigator;
  log.debug(`Got userAgent: ${userAgent}`);

  if (userAgent && userAgent.includes("Firefox")) {
    log.debug("GOT FIREFOX!");
  }

  if (userAgent && userAgent.includes("Chrome-Lighthouse")) {
    log.info("Detected Chrome-Lighthouse, skipping LogRocket initialization.");
    // Don't load LogRocket if the user agent is a Lighthouse Audit Report
    return false;
  }

  if (userAgent === "cca-app-tester") {
    log.info("Detected cca-app-tester, skipping LogRocket initialization.");
    // Don't load LogRocket if the user agent is a Lighthouse Audit Report
    return false;
  }

  return true;
};

const LogRocketLazyLoader = () => {

  log.debug("LogRocketLazyLoader::render()");

  if (!shouldCreateLogRocket()) {
    return (<></>);
  }

  return (
    <>
      <Suspense fallback={<></>}>
        <LogRocketWrapper />
      </Suspense>
    </>
  );
};

export {
  LogRocketLazyLoader
};
